export const DEFAULT_CONFIG = {
  vertical: {
    path: process.env.AD_SQUARE_PATH,
    size: [300, 250],
    id: process.env.AD_SQUARE_ID,
  },
  horizontal: {
    size: [728, 90],
    path: process.env.AD_HORIZONTAL_PATH,
    id: process.env.AD_HORIZONTAL_ID,
  },
  horizontalMobile: {
    size: [320, 50],
    path: process.env.AD_HORIZONTAL_MOBILE_PATH,
    id: process.env.AD_HORIZONTAL_MOBILE_ID,
  },
  login: {
    size: [300, 600],
    path: process.env.AD_LOGIN_PATH,
    id: process.env.AD_LOGIN_ID,
  },
}

/**
 * @param {string} type
 */
export const getPublicityConfigForAdvertType = (type) => {
  const vertical = getVerticalConfig(type)

  console.log(vertical)

  return {
    vertical: vertical ?? DEFAULT_CONFIG.vertical,
  }
}

const getVerticalConfig = (type) => {
  switch (type) {
    case "rental":
      return {
        path: "/3204985/pages_location",
        size: [300, 250],
        id: "div-gpt-ad-1677775630156-0",
      }

    case "sale":
      return {
        path: "/3204985/pages_vente",
        size: [300, 250],
        id: "div-gpt-ad-1696519288226-0",
      }

    default:
      return undefined
  }
}
